import { Component, OnInit, ViewChild, HostBinding, ViewEncapsulation } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import * as _ from 'underscore';
import { Endpoint } from '../../../models/enums';
import { DrRequestInfo } from '../../../models/dr-request-info';
import { GridRowSelectionType, GenericColDef } from '../../../models/grid-context';
import { Timezone } from '../../../models/timezone';
import { GenericGridComponent } from '../../generic-grid/generic-grid.component';
import { BaseModalComponent } from '../../../models/base-modal-component';


@Component({
    standalone: false,
    selector: 'res-timezone-modal',
    templateUrl: './timezone-modal.component.html',
    styleUrls: ['./timezone-modal.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class TimezoneModalComponent extends BaseModalComponent implements OnInit {
    @HostBinding('class') classes = 'maximized-component';
    @ViewChild(GenericGridComponent, { static: true }) genericGrid: GenericGridComponent;


    modalTitle = 'All Time Zones';
    modalAutomationId = 'timezones-modal';
    primaryButtonLabel = 'OK';
    secondaryButtonLabel = 'Cancel';
    modalClass = 'timezone-modal';
    filteredTimezones = [];
    activeFilter = '';
    allTimezoneList = [];
    timezones = [];
    isFistLoad = true;
    selectedTimezone = [];

    columnDefs = new Array<GenericColDef>(
        {
            automationId: this.modalAutomationId,
            field: 'description',
            headerName: 'Timezones',
        }
    );
    rowSelection = GridRowSelectionType.single;
    requestInfo = new DrRequestInfo({
        endpoint: Endpoint.realmManager_listAllTimezones,
        responseName: 'timezones',
        data: {}
    });

    constructor(
        private modalService: BsModalService,
        private modalRef: BsModalRef) {
        super(modalService, modalRef);
    }

    ngOnInit(): void {
        this.genericGrid.loadData();
    }

    responseArrayCallback = (value: any) => new Timezone(value);

    loadDataFinishedCallback = () => {
        if (this.isFistLoad) {
            this.allTimezoneList = this.genericGrid.getData();
        }
        this.isFistLoad = false;
    }

    filterData(str: string): void {
        if (str) {
            this.filteredTimezones = this.allTimezoneList.filter(value => {
                return value.description.toLowerCase().includes(str);
            });
        } else {
            this.filteredTimezones = this.allTimezoneList;
        }
        this.genericGrid.setData(this.filteredTimezones);
    }

    selectedRows(): Timezone[] {
        if (this.genericGrid?.gridApi) {
            return this.genericGrid.gridApi.getSelectedRows();
        }
        return [];
    }

    isPrimaryButtonEnabled(): boolean {
        return this.selectedRows().length > 0;
    }

    ok(): void {
        this.selectedTimezone = this.genericGrid.gridApi.getSelectedRows();
        if (this.selectedTimezone.length > 0) {
            this.closeModal(true, this.selectedTimezone[0]);
        }
    }
}
